import { render, staticRenderFns } from "./TrusteesYN.vue?vue&type=template&id=71f0138e"
import script from "./TrusteesYN.vue?vue&type=script&lang=js"
export * from "./TrusteesYN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports